import { Tooltip, Switch } from "@mui/material";
import { useDisableUser } from "@queries/users/useDisableUser";
import { useEnableUser } from "@queries/users/useEnableUser";
import { useState } from "react";

type Props = {
  userId: string;
  userEnabled: boolean;
};

export const EnableDisableUserSwitch = (props: Props) => {
  const { userId, userEnabled } = props;
  const enableUserMutation = useEnableUser();
  const disableUserMutation = useDisableUser();
  const [enabled, setEnabled] = useState(userEnabled);

  const handleEnableDisableUser = (
    event: React.ChangeEvent<HTMLInputElement>,
    userId: string
  ) => {
    if (event.target.checked) {
      setEnabled(true);
      enableUserMutation.mutate({ userId });
      return;
    }
    setEnabled(false);
    disableUserMutation.mutate({ userId });
  };

  const isMutationLoading =
    enableUserMutation.isPending || disableUserMutation.isPending;

  return (
    <Tooltip
      title={
        userEnabled ? "Click to disable the user" : "Click to enable the user"
      }
    >
      <Switch
        color="primary"
        onChange={(e) => handleEnableDisableUser(e, userId)}
        checked={enabled}
        disabled={isMutationLoading}
      />
    </Tooltip>
  );
};
